import { FormHelperText, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { appNote, buttonLabels } from '../shared/constants';
import DisplayContent from '../shared/display-content.component';
import { validateForm } from '../shared/form-validation';
import UnAuthComponent from '../layout/unauth.component';
import { AppRoutes } from '../routes/route.path';
import { ArrowBackIcon, EmailSentSuccessIcon, FalkonchatIcon, LoginBgMobile, LoginBgTop } from "../../icon";
import { ChannelAuthService } from "../../services/ChannelAuthService";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors'
import { ChannelUserService } from "../../services/ChannelUserService";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";


const ChannelForgotPasswordComponent = () => {

    const navigate = useNavigate();

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const [email, setEmail] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");
    const [emailSent, setEmailSent] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleChange = (name, value) => {
        validateForm({ [name]: value }, (validationErrors) => {
            setEmailError(validationErrors.email || "")
        });
        setEmail(value);
    };


    const forgotPassword = (event: any) => {
        if (validateForm({ email: email }, (Errors) => setEmailError(Errors.email))) {
            setIsLoading(true)
            ChannelAuthService.forgetpassword(email).then((res) => {
                setIsLoading(false)
                setEmail("")
                setEmailSent(true)
            }).catch((err) => {
                setToast(err.response.data.message, ToasterType.DANGER)
                setIsLoading(false)
                setEmail("")
            })
        }
    }

    useEffect(() => {
        if (!!ChannelAuthService.isUserLoggedIn()) {
            navigate(ChannelUserService.hasSysAdminRole() ? AppRoutes.CHANNELS_ORGANISATIONS : AppRoutes.CHANNELS_DASHBOARD)
        }
        else {
            navigate(AppRoutes.CHANNELS_FORGET_PASSWORD);
            localStorage.removeItem("user-token")
            localStorage.removeItem("current-user")
            localStorage.removeItem("Timezone")
            localStorage.removeItem("IsLiveChat")
        }
    }, [])

    return (
        <div className={`w-p-100 h-v-100 d-flex align-center flex-direction`}>
            <div className={`h-p-10 d-flex align-end pl-6 mr-auto`}>
                <FalkonchatIcon />
            </div>
            {!IsMobileDevice &&
                <div className="p-absolute r-0 t-0" style={{ zIndex: -1 }}>
                    <LoginBgTop />
                </div>
            }
            {IsMobileDevice &&
                <div className="p-absolute l-0 b-0" style={{ zIndex: -1 }}>
                    <LoginBgMobile />
                </div>
            }
            <div className={`h-p-90 w-p-100`}>
                {!emailSent ? (
                    <div className="h-p-100 w-p-100 d-flex justify-center align-center flex-direction">
                        <div className={`h-p-10 d-flex justify-center align-start h1-semibold color-login-headers mx-auto ${IsMobileDevice ? "w-p-100" : "w-p-70"}`}>
                            Forgot Password ?
                        </div>
                        <div className={`h-p-6 min-h-6 mx-auto ${IsMobileDevice ? "w-p-70" : "max-w-50 min-w-50"}`}>
                            <TextField
                                className={`w-p-100 h-p-100 unauth-border ${emailError && "unauth-border-error"}`}
                                error={
                                    !!emailError
                                }
                                variant="standard"
                                fullWidth
                                id="email"
                                placeholder=""
                                name="email"
                                autoComplete={""}
                                label="Business Email*"
                                autoFocus
                                value={email}
                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                inputProps={{ tabIndex: 1, "data-arrow-index": 6 }}
                                InputProps={{
                                    classes: { input: 'h4-regular w-p-100' }
                                }}
                            />
                        </div>
                        <div className={`h-p-4 min-h-4 mx-auto ${IsMobileDevice ? "w-p-70" : "max-w-50 min-w-50"}`}>
                            <FormHelperText className="h6-regular color-primary-danger ml-auto">
                                {emailError}
                            </FormHelperText>
                        </div>
                        <div className={`h-p-6 min-h-6 mx-auto ${IsMobileDevice ? "w-p-70" : "max-w-50 min-w-50"}`}>
                            <button
                                data-arrow-index={9}
                                data-up-arrow-index={8}
                                data-down-arrow-index={9}
                                data-left-arrow-index={2}
                                data-right-arrow-index={9}
                                tabIndex={4}
                                onClick={(e) => forgotPassword(e)}
                                className={`c-pointer justify-center d-flex w-space h4-regular w-fill br-2 t-align-center h-p-80 bg-color-login-btn color-secondary w-p-100 align-center`}>
                                {isLoading && <span className="mr-1 loader-primary my-auto"></span>}
                                <span className={"my-auto mr-1"}>Reset password</span>
                            </button>
                        </div>
                        <Link
                            data-arrow-index={1}
                            data-up-arrow-index={1}
                            data-down-arrow-index={2}
                            data-left-arrow-index={1}
                            data-right-arrow-index={1}
                            tabIndex={3}
                            to={AppRoutes.CHANNELS_SIGN_IN}
                            className={`h-p-6 min-h-6 mx-auto ${IsMobileDevice ? "w-p-70" : ""}`}
                        >
                            <span className="d-flex align-center justify-center">
                                <ArrowBackIcon className={"c-pointer float-left w-2 mr-1"}
                                />
                                <span className="h5-medium color-login-text-field-font d-flex f-link-hover">{buttonLabels.BACK_TO_LOGIN}</span>
                            </span>
                        </Link>
                    </div>
                ) : (
                    <div className={`${IsMobileDevice ? "w-p-70" : "max-w-70 min-w-70"} h-p-80 d-flex justify-center align-center mx-auto my-auto`}>
                        <DisplayContent
                            cardTitle={"Email sent"}
                            cardTitleClass={"h1-semibold color-login-headers"}
                            displayMsgClass={`h4-medium color-login-text-field-font t-align-center`}
                            btnClass={`c-pointer bg-color-login-btn color-secondary min-h-5 d-flex justify-center align-center br-2  ${IsMobileDevice ? "h2" : "h4-regular mx-10"
                                }`}
                            btnLabel={buttonLabels.BACK_TO_LOGIN}
                            btnPath={AppRoutes.CHANNELS_SIGN_IN}
                            displayMsg={appNote.RESETPASSWORD_SUCESS}
                            displayIcon={EmailSentSuccessIcon}
                            IsMobileDevice={IsMobileDevice}
                            IconClass="w-20 h-20"
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default (ChannelForgotPasswordComponent);